import { createRouter, createWebHistory } from 'vue-router';
import Invite from '@/views/invite/invite';

import EVoucher from '@/views/evoucher/evoucher';
import Notification from '@/views/notification/notification';
import Shop from '@/views/shop/shop';
import Qrcode from '@/views/qrcode/qrcode';
import UserInfo from '@/views/user/userinfo';
import EditUser from '@/components/EditUser';
import EditingUser from '@/components/EditingUser';
import store from '../store';
import msalInstance from '../msal';

let baseRoute = [
  {
    path: '/',
    name: 'Index',
    component: Notification,
    meta: {
      keepAlive: false,
      requireAuth: true,
      title: '',
      etitle: ''
    }
  },
  {
    path: '/transactions',
    name: 'EVoucher',
    component: EVoucher,
    meta: {
      keepAlive: false,
      requireAuth: true,
      title: '',
      etitle: 'EVoucher'
    }
  },
  {
    path: '/notification',
    name: 'Notification',
    component: Notification,
    meta: {
      keepAlive: false,
      requireAuth: true,
      title: '',
      etitle: 'Notification'
    }
  },
  {
    path: '/shop',
    name: 'Shop',
    component: Shop,
    meta: {
      keepAlive: false,
      requireAuth: true,
      title: '',
      etitle: 'Shop'
    }
  },
  {
    path: '/qrcode',
    name: 'Qrcode',
    component: Qrcode,
    meta: {
      keepAlive: false,
      requireAuth: true,
      title: '',
      etitle: 'QR Code'
    }
  },
  {
    path: '/invite',
    name: 'Invite',
    component: Invite,
    meta: {
      keepAlive: false,
      requireAuth: true,
      title: '',
      etitle: 'Invite'
    }
  },
  {
    path: '/userinfo',
    name: 'UserInfo',
    component: UserInfo,
    meta: {
      keepAlive: false,
      requireAuth: true,
      title: '',
      etitle: 'Profile'
    },
    children: [
      {
        path: 'EditUser',
        component: EditUser,
        meta: {
          keepAlive: false,
          requireAuth: true
        }
      },
      {
        path: 'EditingUser',
        component: EditingUser,
        meta: {
          keepAlive: false,
          requireAuth: true
        }
      }
    ]
  },
  {
    path: '/401',
    name: '无权访问',
    component: () => import('../views/401.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/404',
    name: '找不到页面',
    component: () => import('../views/404.vue'),
    meta: {
      keepAlive: false
    }
  }
];

let router = createRouter({
  history: createWebHistory(),
  routes: baseRoute,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop;
      }
      return { left: 0, top: to.meta.savedPosition || 0 };
    }
  }
});
// ---------- 路由拦截器：登录态检查 ----------
// 时序关键：MSAL 的 initialize → handleRedirectPromise → acquireTokenSilent → 保存 token → 拉 userInfo
// 是一条异步链（initPromise），如果在它完成之前就走 beforeEach，store 为空会被误判为未登录并跳 /401，
// 即使稍后 handleRedirectPromise 成功也只能在 401 页转圈。
// 修复策略：对 requireAuth 的页面，先 await msal 初始化承诺（保证 redirect 回调已被处理），再判断登录态；
// 如果用户已经登录且 MSAL cache 中有 account，同步触发一次 handleToken（命中缓存很快）确保 store 补齐。
router.beforeEach(async (to) => {
  document.title = 'MTR eVoucher Portal';

  if (to.matched.some((record) => record.meta.requireAuth)) {
    // 1) 等待 MSAL 初始化 + handleRedirectPromise 执行完毕（最多等 3s，避免卡死）
    try {
      await Promise.race([
        msalInstance.initialize ? msalInstance.initialize().then(() => msalInstance) : Promise.resolve(msalInstance),
        new Promise((resolve) => setTimeout(resolve, 3000))
      ]);
    } catch (e) {
      console.warn('[Router] msal initialize await failed, proceed with best-effort auth check.', e);
    }

    // 2) 先看 store 中是否已经有完整登录信息
    const hasSignin = !!store.getters.get_Signin_info;
    const hasUserInfo = !!store.getters.get_user_Info_cache;
    if (hasSignin && hasUserInfo) {
      return true;
    }

    // 3) store 里还没填完（典型：刚回调完，acquireTokenSilentAndSetup 还在 getUserInfo）
    //    检查 MSAL cache 中是否已经有 account → 有就说明登录回调已成功，
    //    主动触发 handleToken 补齐 store（走缓存路径很快），避免误跳 401。
    try {
      const accounts = msalInstance.getAllAccounts ? msalInstance.getAllAccounts() : [];
      if (accounts.length > 0) {
        console.info('[Router] has logged-in account in MSAL cache, ensure signin info loaded.');
        // 同步等待一小段时间，让正在进行中的 initPromise 中的 acquireTokenSilentAndSetup 有机会写完 store
        await new Promise((resolve) => setTimeout(resolve, 500));
        const stillMissing =
          !store.getters.get_Signin_info || !store.getters.get_user_Info_cache;
        if (stillMissing) {
          if (typeof msalInstance.handleToken === 'function') {
            msalInstance.handleToken();
          }
        }
        // 这里不强制校验补齐结果：如果还缺，说明 API 调用慢或失败，
        // 先放行让页面进入，失败时 request.js 的 401 拦截会跳去 /401。
        return true;
      }
    } catch (e) {
      console.warn('[Router] msal cache check failed, redirect to /401.', e);
    }

    // 4) 真的没有登录态（MSAL cache 也没 account），去 401 页面触发登录
    return { path: '/401' };
  } else {
    return true;
  }
});
export default router;
